/** Auto-generated by scripts/bake-carousel-strip.mjs — carousel strip tier layouts and content hash (cache-bust query). */
export const CAROUSEL_STRIP_VERSION = "bbb03ae1bc4381f8" as const;
/** Per tier: strip width, full virtual strip height, and each page's virtual rows (top-down). */
export const CAROUSEL_STRIP_TIERS = {
    "lg": {
        "width": 2048,
        "virtualHeight": 20300,
        "pages": [
            {
                "top": 5535,
                "height": 1303
            },
            {
                "top": 6838,
                "height": 1325
            },
            {
                "top": 8163,
                "height": 1325
            },
            {
                "top": 9488,
                "height": 1324
            },
            {
                "top": 10812,
                "height": 1325
            },
            {
                "top": 12137,
                "height": 1325
            },
            {
                "top": 13462,
                "height": 1325
            },
            {
                "top": 14787,
                "height": 1303
            }
        ]
    },
    "sm": {
        "width": 1024,
        "virtualHeight": 10150,
        "pages": [
            {
                "top": 2735,
                "height": 684
            },
            {
                "top": 3419,
                "height": 662
            },
            {
                "top": 4081,
                "height": 663
            },
            {
                "top": 4744,
                "height": 662
            },
            {
                "top": 5406,
                "height": 663
            },
            {
                "top": 6069,
                "height": 662
            },
            {
                "top": 6731,
                "height": 662
            },
            {
                "top": 7393,
                "height": 684
            }
        ]
    }
} as const;
